<template>
  <mdb-modal fullHeight side
             size="sm"
             :removeBackdrop="!isMobileView"
             position="left"
             direction="left"
             :show="show"
             @show="handleShow"
             @close="handleClose"
             class="member-detail">
    <mdb-modal-header>
      <mdb-modal-title>Member Detail</mdb-modal-title>
    </mdb-modal-header>
    <mdb-modal-body>
      <div class="md-form input-group input-group-sm mt-0 mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text md-addon">UID</span>
        </div>
        <input type="text" class="form-control" :value="member.uid" disabled />
      </div>
      <div class="md-form input-group input-group-sm mt-0 mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text md-addon">Mobile</span>
        </div>
        <input type="text" class="form-control" :value="member.channel_id" disabled />
      </div>
      <div class="md-form input-group input-group-sm mt-0 mb-3">
        <div class="input-group-prepend">
          <span class="input-group-text md-addon">Channel</span>
        </div>
        <input type="text" class="form-control" :value="member.channel" disabled />
      </div>
      <div class="form-row">
          <label>Labels</label>
          <multiselect :options="tagsList"
                       placeholder="Select or add Label"
                       label="name"
                       :value="selectedTags"
                       :multiple="true"
                       :taggable="true"
                       @select="handleSelectTag"
                       @remove="handleRemoveTag"
                       @tag="handleAddTag"
                       :clear-on-select="false"
                       :close-on-select="true"></multiselect>
      </div>
      <form @submit.prevent="handleSave">
        <div class="form-row">
          <div class="col-md-12">
            <mdb-input class="member-name"
                       size="sm"
                       :validation="!!(error.name)"
                       :invalid-feedback="error.name"
                       v-model="profile.name" label="UserName" />
          </div>
        </div>
        <div class="form-row">
          <button type="submit" v-if="!loading" class="btn btn-sm btn-default btn-block">SAVE</button>
          <div v-if="loading" class="spinner-border text-info" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="form-group" v-if="motorsInfo.company">
          <div class="motors-row">
            <label>Company</label>
            <a @click="handleCopy(motorsInfo.company)" class="badge badge-default">{{ motorsInfo.company }}</a>
          </div>
          <div class="motors-row" v-if="motorsInfo.email.length > 0">
            <label>Email</label>
              <a :key="email" v-for="email in motorsInfo.email"
                 :href="`mailto:${email}`"
                 target="_blank"
                 class="badge badge-default">{{ email }}</a>
          </div>
          <div class="motors-row" v-if="motorsInfo.contact">
            <label>Contact</label>
            <a @click="handleCopy(motorsInfo.contact)" class="badge badge-default">{{ motorsInfo.contact }}</a>
          </div>
          <div class="motors-row">
            <a :href="motorsInfo.sub_panel" target="_blank" class="btn btn-default btn-sm btn-block waves-effect waves-light">Sub Panel</a>
            <a :href="motorsInfo.policy_list" target="_blank" class="btn btn-default btn-sm btn-block waves-effect waves-light">Policy List</a>
            <a :href="motorsInfo.quotation_list" target="_blank" class="btn btn-default btn-sm btn-block waves-effect waves-light">Quotation List</a>
          </div>
        </div>
        <div class="form-group">
          <div class="motors-row" v-if="motorsInfo.tags.length > 0">
            <label>Labels</label>
            <a v-for="tag in motorsInfo.tags" :key="tag" @click="handleCopy(tag)" class="badge badge-default">{{ tag }}</a>
          </div>
          <div class="motors-row" v-if="motorsInfo.agent.length > 0">
            <label>Referrer</label>
            <a v-for="agent in motorsInfo.agent" :key="agent.sn" @click="handleCopy(agent.company)" class="badge badge-default">{{ agent.company }}</a>
          </div>
          <div class="motors-row" v-if="motorsInfo.tags.length > 0">
            <a :href="motorsInfo.order" target="_blank" class="btn btn-default btn-sm btn-block waves-effect waves-light">Order List</a>
          </div>
          <hr>
          <div class="motors-row">
            <router-link :to="{path: `/export/${member.uid}`}"
                         target="_blank" class="btn btn-outline-light btn-sm btn-block">Export Record</router-link>
          </div>
        </div>
      </form>
      <transition name="fade">
        <div v-if="toastText.length > 0" class="mini-toast z-depth-2" :class="toastClass">{{toastText}}</div>
      </transition>
    </mdb-modal-body>
  </mdb-modal>
</template>

<script>
import mdbInput from "mdbvue/src/components/Forms/Input";
import mdbModal from "mdbvue/src/components/Modals/Modal";
import mdbModalHeader from "mdbvue/src/components/Modals/ModalHeader";
import mdbModalBody from "mdbvue/src/components/Modals/ModalBody";
import mdbModalTitle from "mdbvue/src/components/Modals/ModalTitle";
import multiselect from "vue-multiselect";
import srv from "../Services/UserService";
import tagsService from "@/Services/tagsService";
import "vue-multiselect/dist/vue-multiselect.min.css"
import copy from "copy-to-clipboard";

const userService = new srv();

export default {
  name: "edit-member",

  data() {
    return {
      loading: false,
      error: {},
      selectedTags: [],
      tagsList: [],
      profile: {
        name: "",
      },
      motorsInfo: {
        company: "",
        contact: "",
        phone: "",
        email: "",
        policy_list: "",
        sub_panel: "",
        tags: [],
        agent: [],
        order: "",
      },
      toastText: "",
      toastClass: "",
    };
  },

  props: {
    show: {
      type: Boolean,
      default: true,
    },
    member: {
      type: Object,
      default() {
        return {
          channel: "",
          channel_id: "",
          channel_image: "",
          name: "",
          uid: 0,
          tags: [],
        };
      }
    }
  },

  components: {
    "mdb-modal": mdbModal,
    "mdb-modal-header": mdbModalHeader,
    "mdb-modal-body": mdbModalBody,
    "mdb-modal-title": mdbModalTitle,
    mdbInput,
    multiselect,
  },

  computed: {
    isMobileView() {
      return window.innerWidth < 1024;
    }
  },

  watch: {
    show(val, oldVal) {
      if (val) {
        this.fetchTags();
        this.fetchUserTags();
        this.fetchMotorsInfo();
      } else {
        this.motorsInfo = {
          company: "",
          contact: "",
          phone: "",
          email: "",
          policy_list: "",
          sub_panel: "",
          tags: [],
          agent: [],
          order: "",
        }
      }
    }
  },

  methods: {
    handleClose() {
      this.$emit("close");
    },

    fetchTags() {
      return tagsService.labels().then((data) => {
        this.tagsList = data;
      })
    },

    fetchUserTags() {
      return tagsService.userLabels(this.member.uid).then((data) => {
        this.selectedTags = data;
      })
    },

    fetchMotorsInfo() {
      return userService.motorsInfo(this.member.uid).then((data) => {
        this.motorsInfo = {
          ...this.motorsInfo,
          ...data,
        }
      });
    },

    handleAddTag(label) {
      return tagsService.addUserLabel(this.member.uid, [label])
          .then(() => {
            return this.fetchUserTags();
          }).then(() => {
            userService.forgetUserCache(this.member.uid);

            this.$emit("update", {
              ...this.member,
              tags: this.selectedTags
            });
          })
    },

    handleSelectTag(opt) {
      const target = this.tagsList.find(item => item.term_id === opt.term_id);
      if (target) {
        return tagsService.addUserLabel(this.member.uid, [target.name])
          .then(() => {
            return this.fetchUserTags();
          })
          .then(() => {
            userService.forgetUserCache(this.member.uid);

            this.$emit("update", {
              ...this.member,
              tags: this.selectedTags
            });
          })
      }

      return Promise.reject(new Error('Not found'))
    },

    handleRemoveTag(opt) {
      const target = this.selectedTags.find(item => item.term_id === opt.term_id);
      if (target) {
        return tagsService.removeUserLabel(this.member.uid, [target.term_id])
            .then(() => {
              return this.fetchUserTags();
            })
            .then(() => {
              userService.forgetUserCache(this.member.uid);

              this.$emit("update", {
                ...this.member,
                tags: this.selectedTags
              });
            })
      }
      return Promise.reject(new Error('Not found'))
    },

    handleSave() {
      this.loading = true;
      userService.user(this.member.uid, this.profile.name)
        .then(() => {
          const data = {
            ...this.member,
            name: this.profile.name
          };
          this.$emit("update", data);
          this.handleClose();
        })
        .catch(err => {

          if (err.validate) {
            this.error = Object.fromEntries(Object.entries(err.validate).map(([key, value]) => {
              return [key, value[0]];
            }));

            return;
          }
        })
        .finally(() => {
          this.loading = false;
        })
    },

    handleShow() {
      this.profile.name = this.member.name;
    },


    showToast(text, timeout = 1000, className = "") {
      this.toastText = text;
      this.toastClass = className;
      setTimeout(() => {
        this.toastText = "";
        this.toastClass = "";
      }, timeout);
    },

    handleCopy(text) {
      if (copy(text)) {
        this.showToast("Copied!")
      } else {
        this.showToast("Copy failed!", 3000, "error")
      }
    },
  },
}
</script>

<style lang="scss">
.member-detail {
  .motors-row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    align-content: center;
    gap: 0.5em;
    flex-wrap: wrap;
    margin-bottom: 0.5em;

    label {
      margin-bottom: 0;
    }
  }
  .form-row {
    margin-bottom: 1em;

    .col-md-12 .md-form {
      margin-top: 1em;
    }
  }

  form {
    .member-name.md-form {
      input.form-control{
        color: #495057;
        border-bottom: 1px solid #ced4da;
      }
    }
  }

  .input-group-sm {
    line-height: 1;
  }
  .form-control.form-control-sm {
    height: 1.5em;
  }
  .modal-body {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }
  form .form-row {
    gap: 0.25em;
    align-items: center;
    align-content: center;
  }
  .input-group-sm {
    font-size: 0.8em;

    > .form-control,
    .form-control:not(textarea){
      font-size: inherit;
      height: auto;
    }
    > .input-group-prepend > .input-group-text {
      font-size: inherit;
      padding: 0.25em 0.5em;
    }
  }
}
</style>
